import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { AdminBaseListComponent } from 'src/modules/sm-base/components/admin-base-list/admin-base-list.component';
import { TableData } from 'src/modules/sm-base/models/table-data.model';
import { TableRow } from 'src/modules/sm-base/models/table-row.model';
import { TableCellType } from 'src/modules/sm-base/netgen/TableCellType';
import { TableColumn } from 'src/modules/sm-base/netgen/TableColumn';
import { Objects } from "src/modules/utils/shared/objects";
import { ProjectPlanningTools } from "../../models/project-planning-tools.model";
import { CalendarOutlineTemplate } from '../../netgen/CalendarOutlineTemplate';
import { ProjectPlanningService } from '../../services/project-planning.service';
import { ProjectType } from '../../netgen/ProjectType';

@Component({
    selector: 'app-edit-calendar-outline-templates',
    templateUrl: '../../../sm-base/components/admin-base-list/admin-base-list.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditCalendarOutlineTemplatesComponent extends AdminBaseListComponent<CalendarOutlineTemplate> {

    service = inject(ProjectPlanningService);
    
    definition = ProjectPlanningTools.definitionCalendarOutlineTemplate;

    projectTypes: ProjectType[];
        
    getTable(): TableData {
        return this.app.tTable("entity.CalendarOutlineTemplate.fields", new TableData([
            new TableColumn("title", "", TableCellType.string, 50),
            new TableColumn("description", "", TableCellType.string, -1)
        ], this.listData.map(o => new TableRow(Objects.toString(o.id), o, o)), ["title"]));
    }

    async initAdditionalData(): Promise<void> {
        await this.service.getProjectTypes();
    }
    
        

}
